export default __webpack_public_path__ + "static/app-highlight-mobile-605d4d5a2c92e2cf88fe7534bee4f0a9.png";